import { initTranslatedItems, parseComplexObject } from '../utils/translationProcessor';

export const EXISTING_MATCH_FOUND = 'ELIGIBLE_PLAN_FOUND';
export const CONS = {
  title: 'Existing Account | CVS Health',
  header: 'You have an existing account',
  description: 'Sign in to your CVS Caremark account with one of these usernames.',
  helpLink: 'Need help choosing a username?',
  mostRecent: 'Most recent username',
  previousUsernames: 'Previous usernames',
  signIn: 'Sign in with ',
  username: 'your username',
  newUsername: 'Want to use a new username?',
  createUserName: 'You can create a different username by setting up your new plan.',
  setUp: 'Set up plan',
  choosingAUserName: `These are your usernames from previous plans. You can use any of them to sign in to your CVS Caremark account.`,
  choosingAUserName2: `Once you sign in with one of these usernames, that’s the one you’ll use to access your account moving forward. The other usernames will be deactivated.`
};

export const HELP_CONS = {
  title: 'Choosing a username | CVS Health',
  header: 'Choosing a username',
  description:
    'These are your usernames from previous plans. You can use any of them to sign in to your CVS Caremark account.',
  description2:
    'Once you sign in with one of these usernames, that’s the one you’ll use to access your account moving forward. The other usernames will be deactivated.'
};

// Translation configuration for already-exists page
export const ALREADY_EXISTS_TRANSLATION_CONFIG = [
  { key: 'CONS', value: CONS, message: JSON.stringify(CONS) },
  { key: 'HELP_CONS', value: HELP_CONS, message: JSON.stringify(HELP_CONS) },
  { key: 'EXISTING_MATCH_FOUND', value: EXISTING_MATCH_FOUND, message: EXISTING_MATCH_FOUND }
];

// Helper function to process translated items
export const processAlreadyExistsTranslations = (translatedItems: any) => {
  translatedItems = initTranslatedItems(translatedItems);

  return {
    CONS: parseComplexObject(translatedItems, CONS),
    HELP_CONS: parseComplexObject(translatedItems, HELP_CONS),
    EXISTING_MATCH_FOUND: translatedItems[EXISTING_MATCH_FOUND] || EXISTING_MATCH_FOUND
  };
};
